<script>
	import { page } from '$app/stores';
	import BlogPage from '$lib/components/blog/BlogPage.svelte';
</script>

<BlogPage blogMetadata={$page.data.blogMetadata}>
	<slot />
</BlogPage>
